import { FC } from "react";

const BRAND = "#2563eb";

const CTABanner: FC = () => {
  return (
    <div style={{
      background: BRAND,
      padding: "64px 40px",
      textAlign: "center",
    }}>
      <div style={{ fontSize: 14, color: "rgba(255,255,255,0.7)", marginBottom: 12, fontWeight: 500, letterSpacing: 0.5 }}>
        START FOR FREE • NO CREDIT CARD REQUIRED
      </div>
      <h2 style={{ fontSize: 36, fontWeight: 700, color: "#fff", marginBottom: 14, letterSpacing: -0.5 }}>
        Ready to simplify your PDF workflow?
      </h2>
      {/*<p style={{ fontSize: 16, color: "rgba(255,255,255,0.8)", marginBottom: 32, maxWidth: 460, margin: "0 auto 32px" }}>*/}
      {/*  Join over a billion users. Access 30+ tools, free forever.*/}
      {/*</p>*/}
      <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
        <button style={{
          background: "#fff", color: BRAND, border: "none",
          borderRadius: 10, padding: "13px 32px",
          fontSize: 16, fontWeight: 700, cursor: "pointer", transition: "transform 0.15s",
        }}
          onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.04)"}
          onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}>
          Start for Free
        </button>
        {/*<button style={{*/}
        {/*  background: "transparent", color: "#fff",*/}
        {/*  border: "1px solid rgba(255,255,255,0.5)",*/}
        {/*  borderRadius: 10, padding: "13px 28px",*/}
        {/*  fontSize: 16, cursor: "pointer", transition: "border-color 0.15s",*/}
        {/*}}*/}
        {/*  onMouseEnter={(e) => e.currentTarget.style.borderColor = "#fff"}*/}
        {/*  onMouseLeave={(e) => e.currentTarget.style.borderColor = "rgba(255,255,255,0.5)"}>*/}
        {/*  View Pricing →*/}
        {/*</button>*/}
      </div>
    </div>
  );
};

export default CTABanner;

